import React from 'react';
import { Navigate } from 'react-router-dom';

export const isAuthenticated = () => {
  return !!localStorage.getItem('auth_token');
};

// Untuk route yang hanya bisa diakses jika sudah login
export const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

// Untuk route seperti /login, tidak bisa diakses jika sudah login
export const RedirectIfAuthenticated = ({ children }) => {
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
};
